interface ExamProgressProps {
  totalQuestions: number;
  currentIndex: number;
  answeredQuestions: Set<number>;
  onNavigate: (index: number) => void;
}

export default function ExamProgress({
  totalQuestions,
  currentIndex,
  answeredQuestions,
  onNavigate,
}: ExamProgressProps) {
  const answeredCount = answeredQuestions.size;
  const progressPercent = (answeredCount / totalQuestions) * 100;

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium text-gray-600">
          {answeredCount} of {totalQuestions} answered
        </span>
        <span className="text-sm font-medium text-gray-600">
          {Math.round(progressPercent)}%
        </span>
      </div>

      <div className="h-2 w-full rounded-full bg-gray-200 mb-4">
        <div
          className="h-2 rounded-full bg-primary-600 transition-all duration-300"
          style={{ width: `${progressPercent}%` }}
        />
      </div>

      <div className="flex flex-wrap gap-1.5">
        {Array.from({ length: totalQuestions }, (_, i) => {
          const isAnswered = answeredQuestions.has(i);
          const isCurrent = i === currentIndex;

          let dotClass = "bg-gray-200 text-gray-500 hover:bg-gray-300";
          if (isCurrent) {
            dotClass = "bg-primary-600 text-white ring-2 ring-primary-300";
          } else if (isAnswered) {
            dotClass = "bg-primary-100 text-primary-700 hover:bg-primary-200";
          }

          return (
            <button
              key={i}
              onClick={() => onNavigate(i)}
              className={`flex h-8 w-8 items-center justify-center rounded-md text-xs font-medium transition-all ${dotClass}`}
              title={`Question ${i + 1}${isAnswered ? " (answered)" : ""}`}
            >
              {i + 1}
            </button>
          );
        })}
      </div>
    </div>
  );
}
